import { type IParticipantsImport } from '@/api/endpoints/schools/schoolParticipants';

import { ImportErrorsLog } from './_components/ImportErrorsLog/ImportErrorsLog';
import { ImportInfo } from './_components/ImportInfo/ImportInfo';

export const getAccordionItems = ({ importsData }: { importsData: IParticipantsImport[] }) =>
  importsData.map(
    ({
      total_rows: participantsCount,
      processed_count: importedParticipantsCount,
      error_count: errorParticipantsCount,
      status,
      created_at: createdAt,
      report,
      file: { filename },
    }) => ({
      className: 'test',
      label: (
        <ImportInfo
          participantsCount={participantsCount}
          importedParticipantsCount={importedParticipantsCount}
          errorParticipantsCount={errorParticipantsCount}
          importStatus={status}
          date={createdAt}
          filename={filename}
        />
      ),
      children: (
        <ImportErrorsLog
          errors={report.errors}
          importStatus={status}
        />
      ),
    }),
  );
